import React, { Component } from "react";

import { Card, Container, Row, Col } from "reactstrap";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";

import "./add_user.css";

import { withAuthorization } from "../Session";

import uuid from "uuid";

class AddUser extends Component {
  constructor(props) {
    super(props);
    console.log("AddUser: Constructor");
    this.state = {
      company_name: "",
      firstname: "",
      lastname: "",
      gstin: "",
      mobile_number: "",
      email: "",
      facebookid: "",
      twitterid: "",
      creditdays: "",
      building: "",
      addressline1: "",
      addressline2: "",
      landmark: "",
      city: "",
      company_state: "Karnataka",
      pincode: "",
      address_type: "Warehouse",
      btn_label: "Add Dealer",
      btn_className: "width_max btn ",
      loading: false
    };
  }

  uuidv4Local() {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8; // Changed. == to ===
      return v.toString(16);
    });
  }

  resetSubmitBtn = () => {
    this.setState({ btn_label: "Add Dealer" });
    this.setState({ btn_className: "width_max btn" });
  };

  addUser = event => {
    this.setState({ btn_label: "Please Wait" });
    this.setState({ btn_className: "width_max btn disabled" });
    this.setState({ loading: true });
    const addressUUID = uuid();
    console.log(
      "# # # # #     A d d    User - Starts     # # # # # , addressUUID",
      addressUUID
    );
    console.log(
      "# # # # #    Company Name[",
      this.state.company_name,
      "]",
      " firstname[",
      this.state.firstname,
      " lastname[",
      this.state.lastname,
      " GSTIN[",
      this.state.gstin,
      "]",
      " mobile_number[",
      this.state.mobile_number,
      "]",
      " email[",
      this.state.email,
      "]",
      " facebookid[",
      this.state.facebookid,
      "]",
      " twitterid[",
      this.state.twitterid,
      "]",
      " creditdays[",
      this.state.creditdays,
      "]",
      " building[",
      this.state.building,
      "]",
      " addressline1[",
      this.state.addressline1,
      "]",
      " addressline2[",
      this.state.addressline2,
      "]",
      " landmark[",
      this.state.landmark,
      "]",
      " city[",
      this.state.city,
      "]",
      " company_state[",
      this.state.company_state,
      "]",
      " pincode[",
      this.state.pincode,
      "]",
      " address_type[",
      this.state.address_type,
      "]",
      "   # # # # #"
    );

    const phoneEntered = this.state.mobile_number;
    const gstinEntered = this.state.gstin;

    const addrUUID = this.uuidv4Local();
    const userToAdd = {
      mobile: this.state.mobile_number.trim(),
      userDetails: {
        addressId: addrUUID,
        address: {
          addressId: addrUUID,
          fullName:
            this.state.firstname.trim() + " " + this.state.lastname.trim(),
          addressType: this.state.address_type,
          city: this.state.city.trim(),
          gstin: this.state.gstin.trim(),
          mobile: this.state.mobile_number,
          pincode: this.state.pincode,
          houseAdd:
            this.state.building.trim() + "," + this.state.addressline1.trim(),
          landmark: this.state.landmark.trim(),
          locality: this.state.addressline2.trim(),
          state: this.state.company_state
        },
        customer: {
          creditRemainingDays: parseInt(this.state.creditdays, 10),
          CompanyName: this.state.company_name.trim(),
          active: true,
          banDate: "",
          banHistory: [{ banDate: null, banRevokeDate: null, reason: null }],
          creditDays: parseInt(this.state.creditdays, 10),
          disabled: false,
          emailId: this.state.email.trim(),
          enabled: true,
          facebookId: this.state.facebookid.trim(),
          ownerName:
            this.state.firstname.trim() + " " + this.state.lastname.trim(),
          gstin: this.state.gstin.trim(),
          mobileVerified: true,
          mobile: this.state.mobile_number.trim(),
          reason: "Dealer added through web conrtrol panel",
          twitterId: this.state.twitterid.trim()
        }
      }
    };
    console.log("User to be added is (json) for createUser API: ", userToAdd);
    try {
      this.props.firebase
        .customers() // [ ] BUG: wrong place to check mobile. Should be checked in addresses table.
        .orderByChild("gstin")
        .equalTo(gstinEntered)
        .once("value", snapshot => {
          console.log("GSTIN Check: Data Returned: ", snapshot.val());
          if (snapshot.val() === null) {
            console.log("GSTIN:[ ", gstinEntered, " ] DOES NOT exist");
            // Now check for GSTIN duplicate
            this.props.firebase
              .customers()
              .orderByChild("mobile")
              .equalTo(phoneEntered)
              .once("value", snapshot => {
                console.log("Phone Check: Data Returned: ", snapshot.val());
                if (snapshot.val() === null) {
                  console.log("Phone[ ", phoneEntered, " ] DOES NOT exist");
                  // Add the dealer here
                  axios({
                    method: "post",
                    url:
                      "https://us-central1-aone-mobile-app-backend.cloudfunctions.net/createUser",
                    data: userToAdd,
                    headers: {
                      "Access-Control-Allow-Origin": "*",
                      "Access-Control-Allow-Methods":
                        "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                      crossorigin: true
                    }
                  })
                    .then(response => {
                      console.log(
                        "Response from axios call for adding the customer:",
                        response
                      );
                      // set the success message in the state
                      console.log("Dealer Successfulyl added!");
                      alert("Dealer Successfulyl added!");
                      // re-initialize the state
                      this.setState({
                        company_name: "",
                        firstname: "",
                        lastname: "",
                        gstin: "",
                        mobile_number: "",
                        email: "",
                        facebookid: "",
                        twitterid: "",
                        creditdays: "",
                        building: "",
                        addressline1: "",
                        addressline2: "",
                        landmark: "",
                        city: "",
                        company_state: "",
                        pincode: "",
                        address_type: "",
                        backendValidationPassed: true,
                        backendValidationMsg: "All validations passed!",
                        serverResponse: response,
                        loading: false
                      });
                      this.resetSubmitBtn();
                    })
                    .catch(function(error) {
                      console.log("Error from axios for add customer: ", error);
                      this.resetSubmitBtn();
                    });
                } else {
                  alert("Dealer Not Added! Phone Exists. Please check.");
                  console.log("Phone[ ", phoneEntered, " ] EXISTS");
                  // Handle Error here
                  this.setState({
                    backendValidationPassed: false
                  });
                  this.setState({
                    backendValidationMsg: "Phone already exist!"
                  });
                  this.setState({ loading: false });
                  this.resetSubmitBtn();
                  event.preventDefault();
                }
              });
          } else {
            // (snapshot.val() != null)
            alert("Dealer Not Added! GSTN Exists. Please check.");
            console.log("GSTIN:[ ", gstinEntered, " ] Exists");
            // Handle error here for duplicate GSTIN number
            this.setState({ backendValidationPassed: false });
            this.setState({
              backendValidationMsg: "GSTN already exist!"
            });
            this.setState({ loading: false });
            this.resetSubmitBtn();
            event.preventDefault();
          }
        });
    } catch (err) {
      console.log("Error from firebase: ", err);
      this.resetSubmitBtn();
      this.setState({ loading: false });
    }

    event.preventDefault();
    console.log("# # # # #     A d d    User Ends     # # # # #");
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  componentDidMount() {
    console.log("componentDidMount(): firebase props: ", this.props.firebase);
  }
  componentWillUnmount() {
    console.log("in componentWillUnmount: turning off firebase: ");
    this.props.firebase.customers().off();
  }

  render() {
    // console.log("render(): company_name[ ", company_name, " ]");
    const {
      company_name,
      firstname,
      lastname,
      gstin,
      mobile_number,
      email,
      facebookid,
      twitterid,
      creditdays,
      building,
      addressline1,
      addressline2,
      landmark,
      city,
      company_state,
      pincode,
      address_type,
      loading
    } = this.state;

    // console.log(
    //   "render(): backendValidationPassed [",
    //   backendValidationPassed,
    //   "] ",
    //   "backendValidationMsg [",
    //   backendValidationMsg + "]",
    //   "serverResponse [",
    //   serverResponse + "]"
    // );
    return (
      <Container>
        {loading && <div>Loading ...</div>}
        <Row>
          <Col xs="12">
            <Card body className="form_submit_card">
              <h3 className="text-center text-warning">Company Information</h3>
              <Form onSubmit={this.addUser}>
                <Row className="formsubmit_field_align">
                  <Col md="12" className="form_row_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Company Info</h6>
                    </div>
                  </Col>

                  <Col md="12" className="form_row_algn">
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Company
                          </Label>
                          <Input
                            type="text"
                            name="company_name"
                            id=""
                            placeholder=" *"
                            pattern="[\-\.a-zA-Z0-9\s]{3,}"
                            required
                            autoComplete="off"
                            title="Registered Co. name"
                            value={company_name}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            First Name
                          </Label>
                          <Input
                            type="text"
                            name="firstname"
                            id=""
                            placeholder=" *"
                            pattern="[a-zA-Z]{3,}"
                            autoComplete="off"
                            value={firstname}
                            required
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Last Name
                          </Label>
                          <Input
                            type="text"
                            name="lastname"
                            id=""
                            placeholder=" *"
                            pattern="[a-zA-Z]{1,}"
                            autoComplete="off"
                            value={lastname}
                            required
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Mobile #
                          </Label>
                          <Input
                            type="text"
                            name="mobile_number"
                            id=""
                            placeholder=" * 10 Digits"
                            pattern="[6789][0-9]{9}"
                            required
                            title="10 digits, without +91"
                            value={mobile_number}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            GSTIN
                          </Label>
                          <Input
                            type="text"
                            name="gstin"
                            id=""
                            placeholder=" *"
                            pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                            required
                            title="Valid GSTIN as per Govt. of India standard"
                            value={gstin}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Credit Days *
                          </Label>
                          <Input
                            type="text"
                            name="creditdays"
                            id=""
                            placeholder=" Max 100 days"
                            pattern="^[1-9][0-9]?$|^100$"
                            autoComplete="off"
                            title="Allowed max of 100 days"
                            value={creditdays}
                            required
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="12" className="form_row_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Social</h6>
                    </div>

                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Email Id
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            id=""
                            placeholder=" "
                            autoComplete="off"
                            title="Enter the Company Email id"
                            value={email}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Facebook
                          </Label>
                          <Input
                            type="text"
                            name="facebookid"
                            id=""
                            placeholder=" Facebook Id"
                            autoComplete="off"
                            value={facebookid}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Twitter
                          </Label>
                          <Input
                            type="text"
                            name="twitterid"
                            id=""
                            placeholder=" Twitter handle"
                            autoComplete="off"
                            value={twitterid}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="12" className="form_algn">
                    <div className="d-inline-flex heading_line_belw">
                      <h6 className="row_heading">Address </h6>
                    </div>
                  </Col>
                  <Col md="12" className="form_algn">
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Building/Office
                          </Label>
                          <Input
                            type="text"
                            name="building"
                            id=""
                            placeholder=" *"
                            required
                            value={building}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Street
                          </Label>
                          <Input
                            type="text"
                            name="addressline1"
                            id=""
                            placeholder=" *"
                            required
                            value={addressline1}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Locality
                          </Label>
                          <Input
                            type="text"
                            name="addressline2"
                            id=""
                            placeholder=" *"
                            required
                            value={addressline2}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Landmark
                          </Label>
                          <Input
                            type="text"
                            name="landmark"
                            id=""
                            placeholder="Near . . ."
                            value={landmark}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            City/Town
                          </Label>
                          <Input
                            type="text"
                            name="city"
                            id=""
                            placeholder=" *"
                            required
                            value={city}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            State *
                          </Label>
                          <Input
                            type="select"
                            id=""
                            name="company_state"
                            value={company_state}
                            onChange={this.onChange}
                          >
                            <option value="">Choose State</option>
                            <option value="Karnataka">Karnataka</option>
                            <option value="Puducherry">Puducherry</option>
                            <option value="Tamilnadu">Tamilnadu</option>
                            <option value="Andhrapradesh">
                              Andhra Pradesh
                            </option>
                            <option value="Telengana">Telengana</option>
                            <option value="Kerala">Kerala</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Pin Code
                          </Label>
                          <Input
                            type="text"
                            name="pincode"
                            id=""
                            placeholder="6 Digits"
                            pattern="[0-9]{6}"
                            value={pincode}
                            onChange={this.onChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label className="label_fnt_size text-muted">
                            Address is *
                          </Label>
                          <Input
                            type="select"
                            id=""
                            name="address_type"
                            onChange={this.onChange}
                            value={address_type}
                          >
                            <option value="Choose One">
                              What type of address?
                            </option>
                            <option value="Office">Office</option>
                            <option value="Warehouse">Warehouse</option>
                            <option value="Other">Other</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3" className="submit_btn">
                    <Button
                      color="primary"
                      size="sm"
                      className={this.state.btn_className}
                      disabled={this.state.btn_enabled}
                      type="submit"
                    >
                      {this.state.btn_label}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(AddUser);
